import { Component, OnInit } from '@angular/core';
import { AppService } from '../app.service';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.css']
})
export class PageNotFoundComponent implements OnInit {

  constructor(private appService: AppService) { }

  ngOnInit() {
  }

  /** get text in right language 
  * @param {string} tag - text to load
  */
 get(tag:string):String {
	return this.appService.get(tag);
  }

}
